import { combineReducers } from "redux";
import {
  cityListReducer,
  getCallReducer,
  getPackageDetailsReducer,
  VerfiyUserReducer,
  getPackagesReducer,
  serviceDetailsReducer,
  servicesReducer,
  userLocationReducer,
  sendotp,
  otpverification,
  ImaginetestimonialsReducer,
  package_fill_up_form,
  CreateBookingReducer,
  otpLoginReducer,
  registerUserReducer,
  otpVerificationReducer,
  navCityListReducer,
  setCityReducer,
  setMainSearchReducer,
  customerDetailBookingReducer,
  downloadReportReducer,
  getBlogReducer,
  getCustomerDashboardReducer,
  testimonialsReducer,
  BlogsReducer,
  EditProfileReducer,
  getAllPackageDetailsReducer,
  getDirectReportReducer,
  careerFormReducer,
  jobDataReducer,
  smsConfirm,
  smsCancel,
  smsViewBooking,
  uploadPrescriptionReducer,
  landMarkReducer,
  labpaginationReducer,
  careerpaginationReducer,
  getPackagesCategoryReducer,
  newsLetterReducer,
  unsubReducer,
  postFrenchiseReducer,
  centerAddressReducer,
  collectionAddedCenter,
  paginationReducer,
  familyFriendReducer,
  familyFriendPostReducer,
  addressReducer,
  registerAddressReducer,
  AddFeedbackReducer,
  CartReducer,
  editAddressReducer,
  ReportReducer,
  addToCartReducer,
  getPackParamsReducer,
  deleteCart,
  deleteMulitItemsCart,
  areaPincodeReducer,
  newAddressReducer,
  deleteAddressReduccer,
  EmptycartReducer,
  SelectedSlot,
  getCouponCodeReducer,
  AddonSetter,
  getRedcashReducer,
  getRedcashDetailsReducer,
  getImgPackagesReducer,
  getImgPackagesAddressReducer,
  ImgPackagesReducer,
  setImgCenterAddressReducer,
  getImgTimeSlotReducer,
  getImgDetalReducer,
  mapMyindiaToken,
  LpCityListReducer,
  setLogoutReducer,
  getCurrentLocationReducer,
  getEventReducer,
  getCareerDataReducer,
  getStateReducer,
  getPrescriptionDataReducer,
  getFamilyCartDataReducer,
  getJobPostingCareerData
} from "./Reducers.js";
import lpPackage from "../Pages/LandingPages/LpReducer";
import NewCovidReducer from "../Pages/Covid19/NewCovidReducer";
import Profile from "../components/Cart/PatientDetailsReducer";
import Slot from "../components/Plan-detail/PlanSlotReducer";
import questionsDataReducer from "../Pages/NPSFeedback/FeedbackReducers"; 
import RedoReducers from "../Pages/RedO/RedoReducers.jsx";
import DoctorsReducer from "../Pages/OurDoctors/OurDoctorReducer"
import DLReducers from "../Pages/DoctorListing/DLReducers.jsx";

const reducers = combineReducers({
  packageCategory: getPackagesCategoryReducer,
  packageList: getPackagesReducer,
  packageDetails: getPackageDetailsReducer,
  serviceDetails: serviceDetailsReducer,
  serviceList: servicesReducer,
  callRecieve: getCallReducer,
  cityList: cityListReducer,
  userLocation: userLocationReducer,
  otpLogin: otpLoginReducer,
  registerUser: registerUserReducer,
  otpverification: otpVerificationReducer,
  navCityList: navCityListReducer,
  cityOnTopNav: setCityReducer,
  mainpagesearch: setMainSearchReducer,
  customerBookingDetails: customerDetailBookingReducer,
  downloadReportResponse: downloadReportReducer,
  blogDetails: getBlogReducer,
  customerDashboard: getCustomerDashboardReducer,
  testimonials: testimonialsReducer,
  blogslist: BlogsReducer,
  EditProfile: EditProfileReducer,
  allpackage: getAllPackageDetailsReducer,
  directReports: getDirectReportReducer,
  careerForm: careerFormReducer,
  jobs: jobDataReducer,
  smsConf: smsConfirm,
  smsCncl: smsCancel,
  smsView: smsViewBooking,
  prescription: uploadPrescriptionReducer,
  landMarkLocation: landMarkReducer,
  newsLetter: newsLetterReducer,
  newsUnsubcribe: unsubReducer,
  centerAdress: centerAddressReducer,
  collectionCenter: collectionAddedCenter,
  lpPackage,
  paginationReducer,
  labpaginationReducer,
  careerpaginationReducer,
  familyFriendReducer,
  familyFriendPostReducer,
  addressReducer,
  registerAddressReducer,
  editAddressReducer,
  ReportReducer,
  CartReducer,
  addToCartReducer,
  getPackParamsReducer,
  deleteCart,
  deleteMulitItemsCart,
  areaPincodeReducer,
  newAddressReducer,
  deleteAddressReduccer,
  CreateBookingReducer,
  NewCovidReducer,
  Slot,
  EmptycartReducer,
  SelectedSlot,
  getCouponCodeReducer,
  AddonSetter,
  AddFeedbackReducer,
  getRedcashReducer,
  getRedcashDetailsReducer,
  getImgPackagesReducer,
  getImgPackagesAddressReducer,
  ImgPackagesReducer,
  setImgCenterAddressReducer,
  getImgTimeSlotReducer,
  getImgDetalReducer,
  ImaginetestimonialsReducer,
  mapMyindiaToken,
  LpCityListReducer,
  getCurrentLocationReducer,
  setLogoutReducer,
  getEventReducer,
  getCareerDataReducer,
  getStateReducer,
  postFrenchiseReducer,
  Profile,
  VerfiyUserReducer,
  getPrescriptionDataReducer,
  questionsDataReducer,
  RedoReducers,
  DoctorsReducer,
  DLReducers,
  getFamilyCartDataReducer,
  getJobPostingCareerData
});

export default reducers;
